module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "auto auto",
      "border": "1px solid #cccccc"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border-right": "1px solid #cccccc",
      "display": "grid",
      "grid-template-rows": "270px 270px"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #cccccc",
      "display": "grid",
      "grid-template-columns": "auto auto auto"
    }
  }, [_c('input', {
    ref: "idImgFile1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "idImgFile1",
      "accept": ".jpg,.png"
    },
    on: {
      "change": _vm.onImgChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "252px",
      "height": "252px",
      "margin-left": "10px",
      "margin-top": "10px",
      "border": "1px solid #bbbbbb",
      "position": "relative",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onFileClick1
    }
  }, [_c('img', {
    ref: "idUserImg1",
    staticStyle: {
      "float": "left",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idUserNte1",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "line-height": "250px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.getLangText(_vm.selText1)))])]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-left": "25px",
      "margin-top": "145px"
    },
    on: {
      "click": _vm.onCreateClick1
    }
  }, [_vm._v(_vm._s(_vm.getLangText("生成")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "252px",
      "height": "252px",
      "margin-left": "25px",
      "margin-top": "10px",
      "margin-right": "10px",
      "border": "1px solid #bbbbbb",
      "position": "relative",
      "cursor": "pointer"
    }
  }, [_c('div', {
    ref: "idRstImg1",
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "100%",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idRstNte1",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "line-height": "250px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("效果图")))])])]), _vm._v(" "), _c('div', {
    ref: "idImgPan2",
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "auto auto auto"
    }
  }, [_c('input', {
    ref: "idImgFile2",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "idImgFile2",
      "accept": ".jpg,.png"
    },
    on: {
      "change": _vm.onImgChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "252px",
      "height": "252px",
      "margin-left": "10px",
      "margin-top": "10px",
      "border": "1px solid #bbbbbb",
      "position": "relative",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onFileClick2
    }
  }, [_c('img', {
    ref: "idUserImg2",
    staticStyle: {
      "float": "left",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idUserNte2",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "line-height": "250px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.getLangText(_vm.selText2)))])]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-left": "25px",
      "margin-top": "145px"
    },
    on: {
      "click": _vm.onCreateClick2
    }
  }, [_vm._v(_vm._s(_vm.getLangText("生成")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "252px",
      "height": "252px",
      "margin-left": "25px",
      "margin-top": "10px",
      "margin-right": "10px",
      "border": "1px solid #bbbbbb",
      "position": "relative",
      "cursor": "pointer"
    }
  }, [_c('div', {
    ref: "idRstImg2",
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "100%",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idRstNte2",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "line-height": "250px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("效果图")))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "0px solid blue"
    }
  }, [_c('textarea', {
    ref: "idScenePromt",
    staticStyle: {
      "float": "left",
      "margin-left": "10px",
      "margin-top": "16px",
      "width": "280px",
      "height": "400px"
    },
    attrs: {
      "maxlength": "2900"
    }
  }), _vm._v(" "), _c('input', {
    ref: "idSceneName",
    staticStyle: {
      "float": "left",
      "width": "280px",
      "height": "30px",
      "margin-left": "10px",
      "margin-top": "15px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "display": "grid",
      "grid-template-columns": "1fr auto 1fr"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    ref: "idSaveBtn",
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-right": "10px",
      "margin-top": "16px",
      "min-width": "120px"
    },
    on: {
      "click": _vm.onSaveClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("保存")))]), _vm._v(" "), _c('div')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f740a42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/SceneNew.vue
// module id = 780
// module chunks = 1